import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { signUp } from '../actions/AuthAction';
import { l10n } from '../i18n/Localization';

class SignUpPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validationError: null,
        };

        this.refEmail = React.createRef();
        this.refPassword = React.createRef();
        this.refConfirmPassword = React.createRef();
        this.refDisplayName = React.createRef();
    }

    setValidationError = (hasError, message) => {
        if (hasError === true) {
            this.setState({
                validationError: {
                    message: message,
                }
            });
        } else {
            this.setState({
                validationError: null,
            });
        }
    }

    handleSignUp = () => {
        const email = this.refEmail.current.value;
        const password = this.refPassword.current.value;
        const confirmPassword = this.refConfirmPassword.current.value;
        const displayName = this.refDisplayName.current.value;

        const exp = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/);

        if (!exp.test(email)) {
            this.setValidationError(true, l10n.auth.emailInvalid);
        } else if (!(password.length >= 6)) {
            this.setValidationError(true, l10n.auth.passwordInvalid);
        } else if (!(password === confirmPassword)) {
            this.setValidationError(true, l10n.auth.passwordsNotMatch);
        } else if (!(displayName.length >= 1 && displayName.length <= 20)) {
            this.setValidationError(true, l10n.auth.displayNameInvalid);
        } else {
            this.setValidationError(false);
            this.props.signUp(email, password, displayName);
        }
    };

    render() {
        const { authCompleted, user, authError } = this.props.authState;

        let authHint;
        if (this.state.validationError) {
            authHint = this.state.validationError.message;
        } else if (authCompleted) {
            authHint = authError ? authError.message : '';
        } else {
            authHint = l10n.auth.authenticating;
        }

        let authDiv;
        if (user) {
            authDiv = (
                <div>
                    <div className="mb-3">{l10n.auth.signedInHint}</div>
                    <div className="mb-3">
                        <Link className="btn btn-primary" to="/characters/">{l10n.hint.feature0}</Link>
                    </div>
                    <div className='mb-3'>
                        <Link className="btn btn-primary" to="/characters/identify">{l10n.hint.feature1}</Link>
                    </div>
                    <div id="auth-hint">{authHint}</div>
                </div>
            );
        } else {
            authDiv = (
                <div>
                    <input className="form-control mb-3" type="email" id="email" placeholder={l10n.auth.email} ref={this.refEmail} disabled={!authCompleted} />
                    <input className="form-control mb-3" type="password" id="password" placeholder={l10n.auth.password} ref={this.refPassword} disabled={!authCompleted} />
                    <input className="form-control mb-3" type="password" id="confirm-password" placeholder={l10n.auth.confirmPassword} ref={this.refConfirmPassword} disabled={!authCompleted} />
                    <input className="form-control mb-3" type="text" id="display-name" placeholder={l10n.auth.displayName} ref={this.refDisplayName} disabled={!authCompleted} />
                    <div className="d-flex justify-content-end align-items-center">
                        <span className="mr-3" id="auth-hint">{authHint}</span>
                        <button className="btn btn-success" type="button" id="sign-up" onClick={this.handleSignUp} disabled={!authCompleted}>{l10n.auth.signUp}</button>
                    </div>
                </div>
            );
        }

        const content = (
            <div className="container mt-3">
                {authDiv}
            </div>
        );

        return (
            <div className="SignUpPage">
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content="" />
                    <title>{l10n.auth.signUp} - {l10n.productName}</title>
                </Helmet>
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authState: { ...state.authState },
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signUp: (email, password, displayName) => {
            dispatch(signUp(email, password, displayName));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
